/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { addslashes, htmlspecialchars } from './util.js';
import { update_common_hooks } from './oc-container-compat.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MPlugins } from './plugins.js';
import { MDTimezones } from './timezone.js';
import { MDLocale } from './locale-impl.js';

import { MDMeta } from './meta-data.js';
import { MDTrees } from './tree-data.js';

import { MVTrees } from './trees.js';


/**
 * MVMediaMetadata - setup & manage meta data details view
 */
export let MVMediaMetadata = function($,mj) {

	function _insert_cat_tree_view( md_data, md_data_id, oc_prefix ) {
		var rows_html=[], tl=mj.trees_order.length;
		for( var i=0; i<tl; ++i ) {
			var t_id=mj.trees_order[i], t=mj.trees[t_id];
			var tooltip = mj.role_administrator ? 'tree_id='+t_id : '';
			rows_html.push('<tr class="md-t md-t-'+t_id+'" data-tree_id="'+t_id+'" data-edit="1"><th title="'+htmlspecialchars(tooltip,true,true)+'">'+htmlspecialchars(t.name)+'</th><td></td></tr>');
		}
		var grp_html = '<div class="media-left-container mmd-categories-container" id="'+md_data_id+'_categories">';
		grp_html += '<div class="title" mj_oc_container="#'+md_data_id+'_categories > .content" mj_oc_id="mj_g_'+oc_prefix+'categories" mj_oc_default="open">';
		grp_html += '<span class="open-close-handle"></span><span class="edit-group link" style="display:none" title="'+mjt('md-edit-group')+'" tabindex="0">'+mjt('md-edit-group')+'</span>';
		grp_html += mjt('md-categories');
		grp_html += '</div>';
		grp_html += '<div class="content"><table><tbody>'+rows_html.join('')+'</tbody></table></div>';
		grp_html += '</div>';
		$(grp_html).appendTo(md_data);
	}

	function setupMetadataView( md_data_node, callback, oc_prefix ) {
		var md_data_id = md_data_node.attr('id');
		if( md_data_id=='' ) {
			if( window.MVPageDebug ) window.MVPageDebug.dprint( 'MVMediaMetadata.setupMetadataView() requires node with id' );
			return false;
		}
		// detach #md-data from DOM - significantly improves performance
		var md_data_node_parent = md_data_node.parent();
		var md_data = md_data_node.empty().detach();
		md_data.data('mj-restore-scroll-pos',null);
		md_data.addClass('loading').append('<div class="media-status-container" id="'+md_data_id+'_status" style="display:none"></div>');
		MDMeta.queryGroupedMetaDefs( function(meta_grouped,meta_defs) {
			var cat_trees_inserted = false;
			var mgl = meta_grouped.length;
			for( var i=0; i<mgl; ++i ) {
				var g = meta_grouped[i];
				if( !cat_trees_inserted && g.name.substr(0,7)==='common-' ) {
					_insert_cat_tree_view(md_data,md_data_id,oc_prefix);
					cat_trees_inserted = true;
				}
				var rows_html = [];
				var dl = g.defs.length;
				for( var j=0; j<dl; ++j ) {
					var d = meta_defs[g.defs[j]];
					var ui_mode = d.intr ? 'hide' : (d.options.ui_mode||'show');
					if( !mj.feature_versioning && (d.id==13 || d.id==14) ) {
						// hide version data
						ui_mode = 'hide';
					}
					if( ui_mode!=='hide' ) {
						var tooltip = mj.role_administrator ? 'meta_id='+d.id+', name='+d.name+', type='+MDMeta.getTypeName(d.type,d.list,true) : '';
						rows_html.push('<tr class="md-m md-m-'+d.id+'" data-meta_id="'+d.id+'" data-list="'+d.list+'"'+(ui_mode==='edit'?' data-edit="1"':'')+'>'
											+'<th title="'+htmlspecialchars(tooltip,true,true)+'">'+htmlspecialchars(d.lname)+'</th>'
											+'<td></td>'
										+'</tr>');
					}
				}
				var div_html = '<div class="media-left-container mmd-meta-container" id="'+md_data_id+'_'+g.name+'">';
				div_html += '<div class="title" mj_oc_container="#'+md_data_id+'_'+g.name+' > .content" mj_oc_id="mj_g_'+oc_prefix+g.name+'" mj_oc_default="'+(g.name=='common'||g.name=='categories'?'open':'close')+'">';
				div_html += '<span class="open-close-handle"></span><span class="edit-group link" style="display:none" title="'+mjt('md-edit-group')+'" tabindex="0">'+mjt('md-edit-group')+'</span>';
				div_html += htmlspecialchars(g.lname);
				div_html += '</div>';
				div_html += '<div class="content"><table><tbody>'+rows_html.join('')+'</tbody></table></div>';
				div_html += '</div>';
				$(div_html).appendTo(md_data);
			}
			if( !cat_trees_inserted ) _insert_cat_tree_view(md_data,md_data_id,oc_prefix);

			// setup MediaMetaViewContainer plugins
			MPlugins.iterateByType( 'MediaMetaViewContainer', function( name, plugin ) {
				var p_html = '<div class="media-left-container mmd-ext-container" id="'+md_data_id+'_ext-'+name+'">';
				p_html += '<div class="title" mj_oc_container="#'+md_data_id+'_ext-'+name+' > .content" mj_oc_id="mj_g_'+oc_prefix+'ext-'+name+'" mj_oc_default="close">';
				p_html += '<span class="open-close-handle"></span><span class="edit-group link" style="display:none" title="'+mjt('md-edit-group')+'" tabindex="0">'+mjt('md-edit-group')+'</span>';
				p_html += htmlspecialchars(plugin.getContainerTitle());
				p_html += '</div>';
				p_html += '<div class="content"><table><tbody>'+plugin.getViewSetupRows().join('')+'</tbody></table></div>';
				p_html += '</div>';
				$(p_html).appendTo(md_data);
			} );

			// re-attach md_data_node
			md_data_node_parent.append( md_data );
			// continue specific setup in callback
			callback();
		} );
	}

	function setupMetadataViewData( md_data_node, media_id, dtinfo, hide_empty, query_status, container_callback ) {
		var md_data_id = md_data_node.attr('id');
		// detach #md-data from DOM - significantly improves performance
		var md_data_node_parent = md_data_node.parent();
		var md_data = md_data_node.detach();
		// user can edit this one?
		var can_edit = mj.role_manager && dtinfo.r_edit;
		md_data.removeClass('loading');
		// check (advisory) lock status of media item
		var msc = md_data.children('.media-status-container').css('display','none').empty();
		if( mj.role_manager && query_status ) {
			$.postJSON('json/media/meta-lockstatus', 'media_id='+encodeURIComponent(media_id), function(j) {
				if( j && !j.error && j.locked==1 ) {
					var html = mjt('md-status-locked')
						.replace('%1',htmlspecialchars(j.owner_username))
						.replace('%2',j.owner_user_id)
						.replace('%3',j.remote_addr);
					html += '<small><br />' + mjt('md-status-locked-ltime')+' '.replace('%1',MDLocale.fmt_datetime(j.ltime)) + '</small>';
					msc.html(html).css('display','block');
				}
			} );
		}
		// prepare meta-data table-rows & add meta-id-specific classes (for custom styling and fast queries..)
		$('tr.md-m',md_data).removeClass('md-avl md-e even odd').addClass('md-hide').children('td').empty();
		// prepare display of meta-data and categories
		var data = dtinfo.meta;
		if( data ) {
			// setup MediaMetaViewData plugins
			var mmvd_plugin_ctxs = {};
			MPlugins.iterateByType( 'MediaMetaViewData', function( plugin_name, plugin ) {
				if( plugin.hasOwnProperty('preSetupViewData') ) mmvd_plugin_ctxs[plugin_name] = plugin.preSetupViewData(media_id,dtinfo,md_data);
			} );
			var mmvd_plugins_by_meta_id = MPlugins.getByTypeMappedByMetaId('MediaMetaViewData','setupViewData');
			// setup meta data rows
			$('tr.md-m',md_data).each( function() {
				var tr = $(this);
				var meta_id = tr.data('meta_id');
				var is_list = !!tr.data('list');
				var val_arr = data[meta_id];
				var val_html = '';
				var avl = false;
				// standard row setup
				if( val_arr && val_arr.length ) {
					avl = true;
					val_html = getInteractiveDisplayData(media_id,val_arr,meta_id);
				} else if( !!tr.data('edit') && !hide_empty ) {
					avl = true;
				}
				if( avl ) {
					tr.addClass('md-avl');
					tr.children('td').each( function() {
						$(this).html(wrapWithMetaDataHolder(meta_id,val_html,is_list));
					} );
				}
				// call plugins where available
				if( mmvd_plugins_by_meta_id.hasOwnProperty(meta_id) ) {
					var plugin = mmvd_plugins_by_meta_id[meta_id];
					plugin.setupViewData(media_id,meta_id,tr,val_arr,val_html,dtinfo,mmvd_plugin_ctxs[plugin.name]||null);
				}
				/*MPlugins.iterateByTypeAndMetaId( 'MediaMetaViewData', meta_id, function( plugin_name, plugin ) {
						plugin.setupViewData(media_id,meta_id,tr,val_arr,val_html,dtinfo,mmvd_plugin_ctxs[plugin_name]||null);
					} );*/
			} )
				.filter('.md-avl').removeClass('md-hide');
			//console.timeEnd('set_meta_data');
			MPlugins.iterateByType( 'MediaMetaViewData', function( plugin_name, plugin ) {
				if( plugin.hasOwnProperty('postSetupViewData') ) plugin.postSetupViewData(media_id,dtinfo,md_data,mmvd_plugin_ctxs[plugin_name]||null);
			} );
		}

		// category table-rows
		$('tr.md-t',md_data).removeClass('md-hide md-e even odd').addClass('md-avl').each( function() {
			// set category assignments
			var self_tr = $(this);
			var tree_id = self_tr.data('tree_id');
			var cat_ids = dtinfo.categories[tree_id]||[];
			self_tr.children('td').html(wrapWithTreeDataHolder(tree_id,getCategoryListNodesSnippet(tree_id,cat_ids)));
		} );
		// per-container states & callbacks ...
		md_data.children('.mmd-meta-container,.mmd-categories-container').each( function() {
			var self=$(this), rows=self.find('>.content tr.md-avl');
			if( rows.length>0 ) {
				// set odd and even classes on rows
				rows.filter(':even').addClass('even');
				rows.filter(':odd').addClass('odd');
				// callback..
				if( container_callback ) container_callback(self,rows,can_edit);
			}
			// show/hide container
			self.css('display',rows.length>0?'block':'none');
		} );
		// setup MediaMetaViewContainer plugins
		MPlugins.iterateByType( 'MediaMetaViewContainer', function( name, plugin ) {
			var container = md_data.find('#'+md_data_id+'_ext-'+name).css('display','none'),
				rows = container.find('>.content tr.md-e');
			if( rows.length>0 ) plugin.setupRowsData(container,rows,media_id,dtinfo);
		} );
		// re-attach md_data_node
		md_data_node_parent.append( md_data );
		// update hooks
		update_common_hooks( md_data );
		// eventually restore scroll position
		tryRestoreMetadataViewDataScrollPos(md_data);
	}

	function saveMetadataViewDataScrollPos( md_data_node ) {
		md_data_node.data('mj-restore-scroll-pos',md_data_node.scrollTop());
	}

	function tryRestoreMetadataViewDataScrollPos( md_data_node ) {
		var sp = md_data_node.data('mj-restore-scroll-pos');
		if( sp!==null ) {
			md_data_node.scrollTop(sp);
			md_data_node.data('mj-restore-scroll-pos',null);
		}
	}


	function getCategoryDisplayNameNode( tree_id, cat_id ) {
		var tree = mj.trees[tree_id] || { visible:false },
			tree_nodes = tree.nodes ? tree.nodes : {},
			r;
		if( cat_id==0 ) {
			r = '<i>'+mjt('md-no-category-assigned')+'</i>';
		} else if( cat_id in tree_nodes ) {
			r = htmlspecialchars(tree_nodes[cat_id].name) || '<i>'+mjt('md-no-category-assigned')+'</i>';
		} else {
			r = '<i>'+mjt('md-unknown-category')+'</i>';
			cat_id = -1; // search for "unknown category" is not available yet
		}
		var elem =  $($.parseHTML(r));
		if(tree.visible && cat_id!=-1) {
			elem = $('<span class="link" title="ID '+cat_id+'">'+r+'</span>').click( function(e) {
				if( window.MVMediaPage ) window.MVMediaPage.start_search_categories(tree_id,cat_id);
				return false;
			} );
		}
		if( cat_id!=0 && ( cat_id in tree_nodes ) ) {
			elem.data( 'mj-custom-tooltip', function() {
				return MVTrees.getPathHTML( tree_id, cat_id, function(n_tree_id,n_cat_id,node) {
					var title = node.name+' (ID '+n_cat_id+')',
						show_id = n_cat_id===cat_id;
					var span_html = '<span class="category'+(node.xtype?' '+node.xtype:'')+'" title="'+htmlspecialchars(title,true,true)+'" style="display:inline-block">';
					span_html += (node.parent?'&raquo; ':'');
					span_html += htmlspecialchars(node.name);
					span_html += (show_id?' (ID '+n_cat_id+')':'');
					span_html += '</span>';
					return span_html;
				},' ' );
			} );
		}
		return elem;
	}

	function getCategoryListNodesSnippet( tree_id, cat_ids ) {
		if( cat_ids.length===0 ) return $('<i>'+mjt('md-no-category-assigned')+'</i>');
		var tmp_elems=[];
		var c, cil=cat_ids.length, cat_id;
		for( c=0; c<cil; ++c ) {
			cat_id = cat_ids[c];
			tmp_elems.push( getCategoryDisplayNameNode(tree_id,cat_id) );
			tmp_elems.push( $('<span class="cat-id">'+cat_id+'</span>') );
			if( c!=cil-1 ) tmp_elems.push( $('<br />') );
		}
		return tmp_elems;
	}

	function getItemArrCombinedToDisplayData( media_id, val_arr, meta_id, item_render_cb ) {
		if( val_arr===null ) return '<span class="data" data-listpos="0" data-item=""></span>';	// TODO: or just return an empty string !?
		var md = MDMeta.getDefinition(meta_id);
		var vl = val_arr.length;
		var html = [];
		var i;
		for( i=0; i<vl; ++i ) html.push('<span class="data" data-listpos="'+i+'" data-item="'+htmlspecialchars(val_arr[i],true,true)+'">'+item_render_cb(media_id,val_arr[i],meta_id)+'</span>');
		if( !md.list ) return html.join('<span class="list-sep">, </span>');
		if( md.type==1 ) return html.join('<hr noshade="noshade" />');
		if( md.options.list_mode && md.options.list_mode==='separator' ) {
			var list_sep = md.options.hasOwnProperty('list_sep') && md.options.list_sep.length ? md.options.list_sep.replace(/N/g,'\n') : ',;\n';
			var list_sep1 = '<span class="list-sep">'+list_sep.charAt(0)+' </span>';
			return html.join(list_sep1);
		}
		if( md.type==9 ) {
			var object_sub_type = md.hasOwnProperty('options') && md.options.hasOwnProperty('object_sub_type') ? md.options.object_sub_type : '';
			if( object_sub_type==='file-list' || object_sub_type==='voting-list' ) return html.join('');
		}
		return html.join('<br />');
	}

	function getNonInteractiveDisplayDataItem( media_id, val, meta_id ) {
		return '<span>'+htmlspecialchars(val)+'</span>';
	}

	function getNonInteractiveDisplayData( media_id, val_arr, meta_id ) {
		return getItemArrCombinedToDisplayData(media_id,val_arr,meta_id,MVMediaMetadata.getNonInteractiveDisplayDataItem);
	}

	function getInteractiveDisplayDataItem( media_id, val, meta_id ) {
		var type = MDMeta.getType(meta_id);
		function fmd(d) {
			return MDMeta.getDisplayDataItem(d,meta_id);
		}
		function linked_span( search_val, title, disp_val, xfmd ) {
			return '<span class="link" onclick="MVMediaPage.start_search(\''+htmlspecialchars(addslashes(search_val),true,true)+'\','+meta_id+')"'+(title?' title="'+htmlspecialchars(title,true,true)+'"':'')+'>'+(xfmd?xfmd(disp_val):disp_val)+'</span>';
		}
		switch( type ) {
		case 0: // MT_STRING
		case 2: // MT_INT
		case 5: // MT_DATE
		case 8: // MT_REF_MEDIA
			// other: click triggers search in same meta field
			return linked_span(val,'',val,fmd);
		case 1: // MT_TEXT
			// split to word list, using split-characters: " \t\n,;"
			var html='', last_pos=0, size=val.length, pos, c, frag_size, frag;
			for( pos=0; pos<size; pos++ ) {
				c = val.charAt(pos);
				if( c===' ' || c==='\t' || c==='\n' || c===',' || c===';' ) {
					frag_size = pos-last_pos;
					if( frag_size > 0 ) {
						frag = val.substr(last_pos,frag_size);
						html += linked_span(frag,'',frag,htmlspecialchars);
					}
					last_pos = pos+1;
					html += c==='\n' ? '<br />\n' : c;
				}
			}
			frag_size = size-last_pos;
			if( frag_size > 0 ) {
				frag = val.substr(last_pos,frag_size);
				html += linked_span(frag,'',frag,htmlspecialchars);
			}
			return html;
		case 3: // MT_REAL
			// other: click triggers search in same meta field
			return linked_span(val,val,val,fmd);
		case 4: // MT_BINARY
			return '-binary-data-';
		case 6: // MT_TIME
			val = val.substr(0,8);
			var d2 = val.length===8 ? val.substr(0,6)+'??' : val; // = "HH:mm:??" = seconds ignored in search term
			return linked_span(d2,'',val,fmd);
		case 7: // MT_DATETIME
			var no_time = val.length===10;
			if( no_time ) return linked_span(val,val,val,fmd);
			// date & time
			var disp_data=MDTimezones.datetime_utc2local(val),
				disp_data2=disp_data.substr(11,8),
				disp_d2=MDLocale.fmt_time(disp_data2),
				title = disp_data+' ('+MDTimezones.getTimezoneName()+')\n'+val+' (UTC)';
			if( disp_d2.length ) {
				//YYYY-MM-DD HH:mm:ss
				var search_data1=val.substr(0,10),			// = "YYYY-MM-DD"
					search_data1u2=val.substr(0,17)+'??';	// = "YYYY-MM-DD HH:mm:??" = seconds ignored in search term
				return linked_span(search_data1,title,disp_data.substr(0,10),MDLocale.fmt_date)+', '+linked_span(search_data1u2,title,disp_d2,null);
			}
			return linked_span(val.substr(0,10),title,disp_data.substr(0,10),fmd);
		case 9: // MT_OBJECT
			var md = MDMeta.getDefinition(meta_id);
			var object_sub_type = md.hasOwnProperty('options') && md.options.hasOwnProperty('object_sub_type') ? md.options.object_sub_type : '';
			if( object_sub_type==='file-list' || object_sub_type==='voting-list' ) {
				let fe = JSON.parse(val);
				return linked_span(fe.name||fe.title,'',val,fmd);
			}
			return linked_span(val,'',val,fmd);
		}
	}

	function getInteractiveDisplayData( media_id, val_arr, meta_id ) {
		//console.log('ZZZ => getInteractiveDisplayData()');
		return getItemArrCombinedToDisplayData(media_id,val_arr,meta_id,MVMediaMetadata.getInteractiveDisplayDataItem);
	}

	function refreshSelectedMetadataViewRows( md_data_node, media_id, meta_ids, dtinfo ) {
		for( var i=0; i<meta_ids.length; ++i ) {
			var meta_id=meta_ids[i], self_tr=$('tr.md-m-'+meta_id,md_data_node);
			if( self_tr.length ) {
				var self_td = self_tr.children('td');
				var dh = self_td.children('.data-holder');
				if( dh.length && dh.is(':visible') ) {
					var d = dtinfo.meta[meta_id];
					var rc = d && d.length ? getInteractiveDisplayData(media_id,d,meta_id) : '';
					dh.html(rc+'&nbsp;');
				}
			}
		}
	}

	function loadAuxData( ondone ) {
		MDTrees.ensureTreeDataLoaded(ondone);
	}

	function getMetaDataHolderClassList( meta_id, is_list ) {
		if( Array.isArray(meta_id) ) {
			// .. for multiple fields
			var cns = [];
			for( var i=0; i<meta_id.length; ++i ) {
				var meta_id_i = meta_id[i];
				var cn = 'meta-id-'+meta_id_i;
				if( MDMeta.getIsList(meta_id_i) ) cn += ' meta-id-'+meta_id_i+'-list';
				cns.push(cn);
			}
			return 'multiple-meta-id '+cns.join(' ');
		}
		// .. for single field
		if( typeof is_list === 'undefined' ) is_list = MDMeta.getIsList(meta_id);
		return 'meta-id meta-id-' + meta_id + ( is_list ? ' meta-id-list meta-id-'+meta_id+'-list' : '' );
	}

	function getTreeDataHolderClassList( tree_id, xtype ) {
		return 'tree-id tree-id-' + tree_id + ( xtype ? ' tree-id-'+tree_id+'-'+xtype : '' );
	}


	function wrapWithMetaDataHolder( meta_id, $innerHTML, is_list ) {
		return $('<div class="data-holder '+getMetaDataHolderClassList(meta_id,is_list)+'"></div>').html($innerHTML);
	}

	function wrapWithTreeDataHolder( tree_id, $innerHTML ) {
		return $('<div class="data-holder '+getTreeDataHolderClassList(tree_id)+'"></div>').html($innerHTML);
	}

	return {
		loadAuxData: loadAuxData,

		setupMetadataView: function( md_data_node, callback, oc_prefix ) {
			loadAuxData( function() {
				setupMetadataView(md_data_node,callback,oc_prefix);
			} );
		},

		setupMetadataViewData: setupMetadataViewData,
		saveMetadataViewDataScrollPos: saveMetadataViewDataScrollPos,
		tryRestoreMetadataViewDataScrollPos: tryRestoreMetadataViewDataScrollPos,


		getCategoryDisplayNameNode: getCategoryDisplayNameNode,
		getCategoryListNodesSnippet: getCategoryListNodesSnippet,

		getNonInteractiveDisplayData: getNonInteractiveDisplayData,
		getNonInteractiveDisplayDataItem: getNonInteractiveDisplayDataItem,

		getInteractiveDisplayData: getInteractiveDisplayData,
		getInteractiveDisplayDataItem: getInteractiveDisplayDataItem,

		refreshSelectedMetadataViewRows: refreshSelectedMetadataViewRows,

		getMetaDataHolderClassList: getMetaDataHolderClassList,
		getTreeDataHolderClassList: getTreeDataHolderClassList,

		wrapWithMetaDataHolder: wrapWithMetaDataHolder,
		wrapWithTreeDataHolder: wrapWithTreeDataHolder,
	};
}(jQuery,mj); // namespace MVMediaMetadata
